<template>
  <div v-if="minTable" class="border pa-1 mb-1">
    <div>
      <div class="d-flex align-center">
        {{ $formatDate(attachedReports['report_sent_at']) }}
        <BaseTooltip
          v-if="attachedReports['report_sender']"
          :tooltip="attachedReports['report_sender'].first_name + ' ' + attachedReports['report_sender'].last_name"
        >
          <div class="ml-3 mt-2">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
      <div class="d-flex align-center">
        <template v-if="!!attachedReports['report_sign_photo']">
          <v-dialog v-if="fileType === 'image'" v-model="modal" width="1200">
            <template v-slot:activator="{ on, attrs }">
              <v-btn text icon v-bind="attrs" v-on="on">
                <slot name="icon">
                  <BaseTooltip :tooltip="status.text">
                    <IconTimeControlBill icon="green"/>
                  </BaseTooltip>
                </slot>
              </v-btn>
            </template>
            <v-img :src="apiDomain + '/' + attachedReports['report_sign_photo']" class="mx-auto" contain>
              <template v-slot:placeholder>
                <v-row
                  class="fill-height ma-0"
                  align="center"
                  justify="center"
                >
                  <v-progress-circular
                    indeterminate
                    color="secondary lighten-5"
                  ></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-btn @click="modal = false" fixed top right fab small dark class="mt-16">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-btn
              :href="apiDomain + '/' + attachedReports['report_sign_photo']"
              target="_blank"
              fixed bottom right fab dark
              class="mb-16" color="#277faf"
            >
              <IconsButton icon="button-save" width="30" height="30"/>
            </v-btn>
          </v-dialog>
          <BaseTooltip v-else :tooltip="status.text">
            <PdfModalShow :url="attachedReports['report_sign_photo']"/>
          </BaseTooltip>
        </template>
        <BaseTooltip v-else :tooltip="status.text">
          <div class="d-flex fill-height align-center">
            <IconTimeControlBill
              :icon="status.icon"
              :yellow-color="status.color"
              :gray-color="status.color"
              :red-color="status.color"
              :else-color="status.color"
              class="mr-2"
            />
          </div>
        </BaseTooltip>
        <div class="text-no-wrap">{{ status.date }}</div>
        <BaseTooltip
          v-if="attachedReports['client_person_data'] || attachedReports['report_signer_user']"
          :tooltip="attachedReports['client_person_data']
            ? attachedReports['client_person_data'].first_name + ' ' + attachedReports['client_person_data'].last_name
            : attachedReports['report_signer_user'].first_name + ' ' + attachedReports['report_signer_user'].last_name"
        >
          <div class="ml-3 mt-1">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
      <div class="grid_btn_mobile d-flex justify-space-around align-center">
        <ButtonShow :open-modal="onOpenReport"/>

      </div>
    </div>
  </div>
  <tr v-else>
    <td>
      <div class="d-flex align-center">
        {{ attachedReports['report_sent_at'] }}
        <BaseTooltip
          v-if="attachedReports['report_sender']"
          :tooltip="attachedReports['report_sender'].first_name + ' ' + attachedReports['report_sender'].last_name"
        >
          <div class="ml-3">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
      </div>
    </td>
    <td class="grid">
      <BaseTooltip :tooltip="status.text">
        <div class="d-flex fill-height align-center">
          <template v-if="attachedReports['report_sign_photo']">
            <v-dialog v-if="fileType === 'image'" v-model="modal" width="1200">
              <template v-slot:activator="{ on, attrs }">
                <v-btn text icon v-bind="attrs" v-on="on">
                  <slot name="icon">
                    <IconTimeControlBill icon="green"/>
                  </slot>
                </v-btn>
              </template>
              <v-img
                :src="apiDomain + '/' + attachedReports['report_sign_photo']"
                class="mx-auto"
                contain
              >
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="secondary lighten-5"/>
                  </v-row>
                </template>
              </v-img>
              <v-btn @click="modal = false" fixed top right fab small dark class="mt-16">
                <v-icon>mdi-close</v-icon>
              </v-btn>
              <v-btn
                :href="apiDomain + '/' + attachedReports['report_sign_photo']"
                target="_blank"
                fixed bottom right fab dark
                class="mb-16"
                color="#277faf"
              >
                <IconsButton icon="button-save" width="30" height="30"/>
              </v-btn>
            </v-dialog>
            <PdfModalShow v-else :url="attachedReports['report_sign_photo']"/>
          </template>
          <IconTimeControlBill
            v-else
            :icon="status.icon"
            :yellow-color="status.color"
            :gray-color="status.color"
            :red-color="status.color"
            :else-color="status.color"
          />
        </div>
      </BaseTooltip>
      <div class="d-flex fill-height align-center">
        {{ status.date }}
        <BaseTooltip
          v-if="attachedReports['client_person_data'] || attachedReports['report_signer_user']"
          :tooltip="attachedReports['client_person_data']
            ? attachedReports['client_person_data'].first_name + ' ' + attachedReports['client_person_data'].last_name
            : attachedReports['report_signer_user'].first_name + ' ' + attachedReports['report_signer_user'].last_name"
        >
          <div class="ml-3 mt-1">
            <IconsButton icon="button-contact" width="24" height="24" color="#277FAF"/>
          </div>
        </BaseTooltip>
        <div class="ml-3">
          <ButtonShow :open-modal="onOpenReport"/>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import BaseTooltip from 'components/base/BaseTooltip.vue'
import IconsButton from '../../icons/button/IconsButton'
import IconTimeControlBill from 'components/icons/timeControl/IconTimeControlBill.vue'
import ButtonShow from '../../ButtonShow.vue'
import PdfModalShow from "../../pdf/PdfModalShow"
import {mapGetters} from 'vuex'

export default {
  name: 'ProjectReportsEmailTable',
  components: {ButtonShow, IconsButton, IconTimeControlBill, BaseTooltip, PdfModalShow},
  props: {
    attachedReports: [Array, Object],
    minTable: Boolean,
    parentReportId: {},
    projectId: {},
    modal: Boolean,
  },
  computed: {
    ...mapGetters(['apiDomain']),
    status() {
      switch (this.attachedReports['report_status']) {
        case 'sent':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].sent,
            icon: 'yellow',
            color: 'var(--v-warning-lighten1)',
            date: this.$formatDate(this.attachedReports['report_sent_at']),
          }
        case 'approved':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].approved,
            icon: 'yellow',
            color: 'var(--v-success-lighten5)',
            date: this.$formatDate(this.attachedReports['report_sent_at'])
          }
        case 'viewed':
          return {
            text: this.localStorage.translations.pages.projects['reports_table']['viewed'],
            icon: 'yellow',
            color: 'var(--v-warning-base)',
            date: this.$formatDate(this.attachedReports['report_opened_at']),
          }
        case 'signed':
          return {
            text: this.localStorage.translations.pages.projects['reports_table'].signed,
            icon: 'green',
            color: 'var(--v-success-base)',
            date: this.$formatDate(this.attachedReports['report_signed_at']),
          }
        case 'expired':
          return {
            text: this.localStorage.translations.pages.projects['reports_table']['expired'],
            icon: 'gray',
            color: 'var(--v-error-base)',
            date: this.$formatDate(this.attachedReports['report_link_expired_at']),
          }
        default:
          return {}
      }
    },
    fileType() {
      if (this.attachedReports['report_sign_photo']) {
        if (typeof this.attachedReports['report_sign_photo'] === 'string')
          return this.attachedReports['report_sign_photo'].split('.')[1] === 'pdf'
            ? 'application'
            : 'image'
        return this.attachedReports['report_sign_photo'].type.split('/')[0]
      }
      return ''
    },
  },
  methods: {
    onOpenReport() {
      this.$router.push({
        name: 'timeControlShowReportsViewBill',
        params: {id: this.projectId, report_id: this.parentReportId, bill: this.attachedReports.id},
      })
    },
  },
}
</script>

<style scoped lang="scss">
.grid {
  padding-left: 12px;
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 40px 1fr;
  align-items: center;

  &_btn_mobile {
    height: 100%;
    min-height: 50px;
    gap: 5px;

    :deep() .v-btn {
      background-color: transparent !important;
      color: #277faf !important;
      max-height: 40px !important;
    }
  }

  &_btn {
    display: grid;
    grid-template-columns: 50px 50px 50px;
    height: 100%;
    gap: 5px;
    justify-items: center;
    margin-left: 20%;

    :deep() .v-btn {
      background-color: transparent !important;
      color: #277faf !important;
      max-height: 40px !important;
    }
  }
}

.line {
  min-height: 55px;
  border-bottom: 1px solid gainsboro;

  &:last-child {
    border-bottom: none;
  }
}

.border {
  border: 1px solid rgba(black, 0.1);
  border-radius: 4px;
}

.fileInput {
  display: none;
}
</style>